// extracted by mini-css-extract-plugin
export default {"input":"DisplayNameInput_input__FcCAw","fullWidth":"DisplayNameInput_fullWidth__pC52Z"};